// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { ReactComponent as Bolt } from '../../../../assets/svg/bolt.svg';
import { __ } from '../../../../i18n/l10n';

import Primary from './Primary';

const StyledButton = styled(Primary)`
  && {
    display: flex;
    align-items: center;
    justify-content: space-around;
    text-transform: capitalize;
    min-width: auto;

    &:active {
      transform: scale(0.9);
    }

    ${({ theme }) => css`
      background-color: ${theme.grids.colors.darkgrey3};
      color: ${theme.grids.colors.middlegrey3};
    `}
  }
`;

const StyledBolt = styled(Bolt)`
  height: 1.4em;
  min-height: 1.4em;
  fill: #fff;
  stroke-width: 1em;
`;

type GridsFlashButtonProps = {
  className?: string;
  onClick: () => void;
};

const GridsFlashButton = ({ className, onClick }: GridsFlashButtonProps) => {
  return (
    <StyledButton onClick={onClick} className={className} data-testid="flash-button">
      <StyledBolt />
      {__('Flash')}
    </StyledButton>
  );
};

export default GridsFlashButton;
